import React, { useEffect, useRef, useState } from 'react';
import './Splash.css';

export default function Splash({ message = 'jizoNN', onFinish }) {
  const [fade, setFade] = useState(false);
  const [showText, setShowText] = useState(false);
  const finishedRef = useRef(false);
  const timers = useRef([]);

  useEffect(() => {
    const currentTimers = timers.current;
    const img = new Image();
    img.src = '/avatar/indiano.png';

    if (typeof document !== 'undefined') {
      document.body.classList.add('splash-locked');
    }

    const prefersReduced = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      setShowText(true);
      currentTimers.push(window.setTimeout(() => setFade(true), 700));
      currentTimers.push(window.setTimeout(() => {
        if (!finishedRef.current) {
          finishedRef.current = true;
          onFinish?.();
        }
      }, 1600));
      return () => {
        currentTimers.forEach(clearTimeout);
        if (typeof document !== 'undefined') {
          document.body.classList.remove('splash-locked');
        }
      };
    }

    currentTimers.push(window.setTimeout(() => {
      setShowText(true);
      currentTimers.push(window.setTimeout(() => setFade(true), 700));
    }, 900));

    currentTimers.push(window.setTimeout(() => {
      if (!finishedRef.current) {
        finishedRef.current = true;
        onFinish?.();
      }
    }, 3000));

    return () => {
      currentTimers.forEach(clearTimeout);
      if (typeof document !== 'undefined') {
        document.body.classList.remove('splash-locked');
      }
    };
  }, [onFinish]);

  const handleImageAnimationEnd = () => {
    if (!showText) {
      setShowText(true);
      timers.current.forEach(clearTimeout);
      timers.current.push(window.setTimeout(() => setFade(true), 600));
      timers.current.push(window.setTimeout(() => {
        if (!finishedRef.current) {
          finishedRef.current = true;
          onFinish?.();
        }
      }, 1800));
    }
  };

  const handleOverlayAnimationEnd = (e) => {
    if (!fade) return;
    const name = (e.animationName || '').toLowerCase();
    if (name.includes('fadeout') && !finishedRef.current) {
      finishedRef.current = true;
      onFinish?.();
    }
  };

  return (
    <div
      className={`splash-overlay ${fade ? 'fade-out' : 'fade-in'}`}
      onAnimationEnd={handleOverlayAnimationEnd}
      role="dialog"
      aria-label="Loading"
    >
      <div className="splash-content" aria-hidden={false}>
        <img
          src="/avatar/indiano.png"
          alt="lebron"
          className={`splash-lebron ${showText ? 'settled' : ''}`}
          width="200"
          height="200"
          onAnimationEnd={handleImageAnimationEnd}
          draggable="false"
        />
        <div className={`splash-text ${showText ? 'visible' : ''}`}>{message}</div>
      </div>
    </div>
  );
}
